var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPorte(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1020",
    fill: "#09253e",
    stroke: "#09253e",
    strokeMiterlimit: 11.34,
    d: "M 6.25,44.62 H 8 V 7.2 h 34 v 37.42 h 1.75 V 5.38 H 6.25 Z",
    style: {
      fill: "#000000",
      strokeWidth: 1,
      strokeDasharray: "none",
      stroke: "#09253e",
      strokeOpacity: 1,
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#09253e",
    stroke: "#09253e",
    strokeMiterlimit: 3,
    x1: 42,
    y1: 44.619999,
    x2: 8,
    y2: 44.619999,
    id: "line1",
    style: {
      fill: "#000000",
      strokeWidth: 1,
      strokeDasharray: "none",
      stroke: "#09253e",
      strokeOpacity: 1,
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#09253e",
    stroke: "#09253e",
    strokeMiterlimit: 3,
    x1: 27.379999,
    y1: 7.3000002,
    x2: 27.379999,
    y2: 44.619999,
    id: "line2",
    style: {
      fill: "#000000",
      strokeWidth: 1,
      strokeDasharray: "none",
      stroke: "#09253e",
      strokeOpacity: 1,
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none",
      strokeOpacity: 1,
      fillOpacity: 0
    },
    d: "m 33.375,20.995 3.75,-3.75",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 24.25,21.395493 V 32.6254",
    id: "path4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4",
    transform: "translate(7.9397048,-6.8174555)",
    style: {
      stroke: "#09253e",
      strokeOpacity: 1,
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 22.435295,24.812455 5.25,-5.25",
    id: "path5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorte);
export default __webpack_public_path__ + "static/media/porte.5256d988e49089fbeffeb45cb7fd94bc.svg";
export { ForwardRef as ReactComponent };